import { ICustomAttributeConfiguration } from '../models';

export function useGetSortedCustomAttributeConfigurations(
    attributes?: ICustomAttributeConfiguration[],
): ICustomAttributeConfiguration[] {
    return (
        attributes?.sort((a, b) =>
            a.type === b.type ? a.name.localeCompare(b.name) : a.type?.toString().localeCompare(b.type?.toString()),
        ) || []
    );
}
